import lodashGet from 'lodash/get';
import { findTag, addTimelineTag, addTimeline } from '../../common/timeline';
export var MessageAction;
(function (MessageAction) {
    MessageAction[MessageAction["UPDATE_OLDEST_MSGTIME"] = 0] = "UPDATE_OLDEST_MSGTIME";
    MessageAction[MessageAction["RESET_SESSION"] = 1] = "RESET_SESSION";
    MessageAction[MessageAction["PREPEND_MSGS"] = 2] = "PREPEND_MSGS";
    MessageAction[MessageAction["INIT_MSGS"] = 3] = "INIT_MSGS";
    MessageAction[MessageAction["PUSH_MSG"] = 4] = "PUSH_MSG";
    MessageAction[MessageAction["REPLACE_MSG"] = 5] = "REPLACE_MSG";
    MessageAction[MessageAction["UPDATE_READS"] = 6] = "UPDATE_READS";
    MessageAction[MessageAction["DELETE_MSG"] = 7] = "DELETE_MSG";
    MessageAction[MessageAction["UNSHIFT_MSG"] = 8] = "UNSHIFT_MSG";
    MessageAction[MessageAction["ADD_REPLY_MSG"] = 9] = "ADD_REPLY_MSG";
    MessageAction[MessageAction["MERGE_MSGS"] = 10] = "MERGE_MSGS";
})(MessageAction || (MessageAction = {}));
export var FileMessageCustomEvent;
(function (FileMessageCustomEvent) {
    FileMessageCustomEvent[FileMessageCustomEvent["BEGIN_UPLOAD"] = 0] = "BEGIN_UPLOAD";
    FileMessageCustomEvent[FileMessageCustomEvent["UPLOAD_PROGRESS"] = 1] = "UPLOAD_PROGRESS";
    FileMessageCustomEvent[FileMessageCustomEvent["UPLOAD_COMPLETE"] = 2] = "UPLOAD_COMPLETE";
    FileMessageCustomEvent[FileMessageCustomEvent["BEFORE_SEND"] = 3] = "BEFORE_SEND";
})(FileMessageCustomEvent || (FileMessageCustomEvent = {}));
const removeDuplicateMsg = (msglist) => {
    const idClients = new Set([]);
    return msglist.filter(item => {
        if (idClients.has(item.idClient)) {
            return false;
        }
        idClients.add(item.idClient);
        return true;
    });
};
export const reduce = (state, action) => {
    const { type, payload } = action;
    const newState = Object.assign({}, state);
    switch (type) {
        case MessageAction.UPDATE_OLDEST_MSGTIME:
            newState.oldestMsgTime = payload.timestamp;
            newState.hasPrev = lodashGet(newState, 'msgList[0].time', 0) > payload.timestamp;
            break;
        case MessageAction.RESET_SESSION:
            newState.msgList = [];
            break;
        case MessageAction.PREPEND_MSGS:
            newState.hasPrev = lodashGet(payload, 'msgList[0].time', 0) > newState.oldestMsgTime;
            const msglistAddedTimelinetag = addTimeline(payload.msgList);
            newState.msgList = msglistAddedTimelinetag;
            break;
        case MessageAction.INIT_MSGS:
            newState.hasPrev = true;
            break;
        case MessageAction.PUSH_MSG:
            const { timeTagIndex: addTagIndex, timeTagValue: addTagValue } = findTag(state.msgList);
            const [aMsgAddedTimeline] = addTimelineTag([payload.msg], addTagValue, addTagIndex);
            newState.msgList.push(aMsgAddedTimeline);
            newState.msgList = removeDuplicateMsg(newState.msgList);
            break;
        case MessageAction.REPLACE_MSG:
            const index = newState.msgList.findIndex(item => item.idClient === payload.msg.idClient);
            const { timeTagIndex: replaceIndex, timeTagValue: replaceVal } = findTag(state.msgList, index - 1);
            const [rMsgAddedTimeline] = addTimelineTag([payload.msg], replaceVal, replaceIndex);
            newState.msgList.splice(index, 1, rMsgAddedTimeline);
            break;
        case MessageAction.DELETE_MSG:
            newState.msgList.splice(state.msgList.findIndex(item => item.idClient === payload.idClient), 1);
            break;
        default:
            break;
    }
    console.log('[message]', newState);
    newState.msgList = newState.msgList.filter((item) => {
        return lodashGet(item, 'text', '') !== 'CREATE_CONVERSATION_MSG';
    });
    return newState;
};
export const MESSAGE_LIMIT = 30;
export const initState = {
    hasPrev: true,
    oldestMsgTime: Infinity,
    msgList: [],
};
